import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';
import { PruHttpService } from "../../services/pru-http.service";

@Component({
  selector: 'pma',
  templateUrl: './pma.component.html',
  styleUrls: ['./pma.component.scss']
})
export class PmaComponent implements OnInit {
  compData: any;
  genericAggregator: any;
  constructor(
    private _pruHttpService: PruHttpService,
    public _genericService: GenericService) { }

  ngOnInit() {
    const pmaUrl = "/api/co/secure/myaccounts/v2/accountsummary?buName=BYC";
    this._pruHttpService.get(pmaUrl, 'PMA').subscribe(data => {
      this.compData = data;
      this._genericService.updateResArr(this.compData['contractSummaryResponse'] || {});
    },
    error=>{
      console.error("Error retrieving PMA accounts", error);
      this.compData = { responseCode: error.status, businessUnit: "Investments" };
      this._genericService.updateResArr(this.compData);
    });
  }

}
